// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"richContentSections-module--imageWrapper--5mOV9","caption":"richContentSections-module--caption--1f_Tg"};